import { useState } from 'react';
import { useLocation } from 'react-router-dom';

const useTablePage = (defaultLimit = 10) => {
  const { pathname } = useLocation();

  const [page, setPage] = useState(() => {
    const saved = sessionStorage.getItem(`tp_page_${pathname}`);
    return saved ? Number(saved) : 1;
  });

  const [limit, setLimit] = useState(() => {
    const saved = sessionStorage.getItem(`tp_limit_${pathname}`);
    return saved ? Number(saved) : defaultLimit;
  });

  const handlePageChange = (p) => {
    setPage(p);
    sessionStorage.setItem(`tp_page_${pathname}`, p);
  };

  const handleSizePerPageChange = (e) => {
    const val = Number(e.target.value);
    setLimit(val);
    setPage(1);
    sessionStorage.setItem(`tp_limit_${pathname}`, val);
    sessionStorage.setItem(`tp_page_${pathname}`, 1);
  };

  return { page, limit, handlePageChange, handleSizePerPageChange };
};

export default useTablePage;
